
import Vue from "vue";
import { BaseLoading } from "@/components/BaseLoading";
import InquiryVerify from "@/components/InquiryVerify/InquiryVerify.vue";
import { authAPI } from "@/api";
export default Vue.extend({
  name: "App",
  components: {
    BaseLoading,
    InquiryVerify,
  },
  mounted() {
    if (this.$store.state.queryParams?.token) {
      const parsedToken = this.parseJwt(this.$store.state.queryParams?.token)
      if (parsedToken.colorPrimary) {
        this.changeColor(parsedToken.colorPrimary);
      }
    }
  },
  methods: {
    changeColor(color: string) {
      this.$vuetify.theme.themes.light.primary = color;
    },
    parseJwt (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    }
  },
  watch: {
    $route(to, from) {
      if (!this.$route?.fullPath.includes("ziarat-register-without-auth")) {
        this.$store.commit("showLoading", true);
        authAPI
          .verify({ token: this.$store.state.queryParams?.token })
          .then((res) => {
            if (!res || res.status !== 200) {
              // document.location.href = "https://app.badesaba.ir";
            }
          })
          .catch(() => {
            // document.location.href = "https://app.badesaba.ir";
          })
          .then(() => {
            this.$store.commit("showLoading", false);
          });
      }
    },
  },
});
